/** Link types scheme */
var ViewType;
(function (ViewType) {
    /** solid underline */
    ViewType["default"] = "default";
    /** solid underline on hover */
    ViewType["default_hover"] = "default-hover";
    /** dashed underline */
    ViewType["dropdown"] = "dropdown";
    /** dashed underline on hover */
    ViewType["dropdown_hover"] = "dropdown-hover";
    /** link with arrow */
    ViewType["modal"] = "modal";
    /** underlined link with arrow */
    ViewType["modal_underline"] = "modal-underline";
    /** underlined link with arrow on hover */
    ViewType["modal_hover"] = "modal-hover";
    /** disabled link */
    ViewType["disabled"] = "disabled";
})(ViewType || (ViewType = {}));
/** Color scheme for link text */
var ThemePalette;
(function (ThemePalette) {
    /** base color */
    ThemePalette["primary"] = "primary";
    /** additional color */
    ThemePalette["additional"] = "additional";
    /** inverse color */
    ThemePalette["inverse"] = "inverse";
    /** success color */
    ThemePalette["success"] = "success";
    /** fail color */
    ThemePalette["fail"] = "fail";
})(ThemePalette || (ThemePalette = {}));
/** Link size scheme */
var LinkSize;
(function (LinkSize) {
    /** size 8px */
    LinkSize["micro"] = "micro";
    /** size 12px */
    LinkSize["small"] = "small";
    /** size 14px */
    LinkSize["regular"] = "regular";
    /** size 16px */
    LinkSize["main"] = "main";
    /** size 18px */
    LinkSize["medium"] = "medium";
    /** size 25px */
    LinkSize["big"] = "big";
    /** size 48px */
    LinkSize["bigger"] = "bigger";
})(LinkSize || (LinkSize = {}));
export { LinkSize as L, ThemePalette as T, ViewType as V };
